import { LinkedRecordData } from '../../../hooks/use-linked-records';

function tasksOnlyFilter(summaryRecords: LinkedRecordData[]) {
  return summaryRecords.filter((summaryRecord) => (
    summaryRecord.linkedFieldKey === 'x758'
  ));
}

export default tasksOnlyFilter;
